export default __webpack_public_path__ + "static/media/brkfst_cereal.e128e169.jpg";